export default __webpack_public_path__ + "static/32-388f19b4ad201a785788a39e65edd2a9.png";